import { Asterisk } from "lucide-react";
import { LOGOS, PROMISES, SERVICES } from "../../data/content";
import { Reveal } from "./Primitives";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {[...SERVICES, ...PROMISES].map((s, i) => (
      <span key={s} className="flex items-center">
        <span className={`whitespace-nowrap px-8 font-display text-5xl font-semibold tracking-[-0.03em] sm:text-7xl ${i % 2 ? "font-serif font-normal italic text-cobalt-700" : "text-ink"}`}>{s}</span>
        <Asterisk className="h-8 w-8 text-ink/30" />
      </span>
    ))}
  </div>
);

export const EditorialMarquee = () => (
  <section data-testid="editorial-marquee" className="relative overflow-hidden border-y border-ink/10 bg-white py-10">
    <div className="marquee flex w-max">
      <Row /><Row />
    </div>
  </section>
);

export const LogoWall = () => (
  <section data-testid="client-logo-wall" className="mx-auto max-w-7xl px-5 py-20 sm:px-8">
    <Reveal>
      <p className="mb-10 text-center text-[13px] font-semibold uppercase tracking-[0.22em] text-ink/60">Over 100 clients · From AI startups to enterprise travel</p>
    </Reveal>
    <div className="grid grid-cols-2 border-l border-t border-ink/10 sm:grid-cols-3 lg:grid-cols-6">
      {[...LOGOS, null].map((src, i) => (
        <div key={src || i} className="group flex h-28 items-center justify-center border-b border-r border-ink/10 px-6 transition-colors duration-500 hover:bg-white">
          {src ? (
            <img src={src} alt="Coenzio client logo" loading="lazy" className="max-h-9 max-w-[130px] object-contain opacity-60 grayscale transition duration-500 group-hover:opacity-100 group-hover:grayscale-0" />
          ) : (
            <span className="font-serif text-xl italic text-cobalt-700">& 90+ more</span>
          )}
        </div>
      ))}
    </div>
  </section>
);
